import React, { PureComponent } from "react";

export default class RemoveEmoji extends PureComponent {
  render() {
    return (
      <svg
        focusable="false"
        aria-hidden="true"
        width="18px"
        height="18px"
        viewBox="0 0 12 12"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <defs />
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g fill="#fff">
            <path d="M6,4.57404357 L1.72275218,0.296795747 C1.32616461,-0.0997918243 0.689941269,-0.0975927221 0.296174273,0.296174273 C-0.100337993,0.69268654 -0.097314479,1.32864195 0.296795747,1.72275218 L4.57404357,6 L0.296795747,10.2772478 C-0.0997918243,10.6738354 -0.0975927221,11.3100587 0.296174273,11.7038257 C0.69268654,12.100338 1.32864195,12.0973145 1.72275218,11.7032043 L6,7.42595643 L10.2772478,11.7032043 C10.6738354,12.0997918 11.3100587,12.0975927 11.7038257,11.7038257 C12.100338,11.3073135 12.0973145,10.671358 11.7032043,10.2772478 L7.42595643,6 L11.7032043,1.72275218 C12.0997918,1.32616461 12.0975927,0.689941269 11.7038257,0.296174273 C11.3073135,-0.100337993 10.671358,-0.097314479 10.2772478,0.296795747 L6,4.57404357 Z" />
          </g>
        </g>
      </svg>
    );
  }
}

RemoveEmoji.displayName = "RemoveEmoji";
RemoveEmoji.vstuiName = "Icon";
